const isArrayHasItems = (value: unknown): value is unknown[] =>
  !!value && Array.isArray(value) && !!value.length;

export default isArrayHasItems;
